<div class="bugs-page">
  <div class="page-header">
    <div>
      <h1>Bugs &amp; QA</h1>
      <p class="subtitle">Report and track defects against project tasks.</p>
    </div>
    <button mat-raised-button color="primary" type="button" (click)="showCreate = !showCreate">
      <mat-icon>bug_report</mat-icon> Report Bug
    </button>
  </div>

  <div class="toolbar">
    <mat-form-field appearance="outline">
      <mat-label>Filter by project</mat-label>
      <mat-select [(ngModel)]="filterProjectId" (ngModelChange)="onFilterChange()">
        <mat-option value="">All projects</mat-option>
        @for (p of projects(); track p.id) {
          <mat-option [value]="p.id">{{ p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="loadBugs()"><mat-icon>refresh</mat-icon> Refresh</button>
  </div>

  @if (error()) {
    <div class="error">{{ error() }}
      <button mat-icon-button type="button" (click)="error.set(null)"><mat-icon>close</mat-icon></button>
    </div>
  }

  @if (showCreate) {
    <mat-card class="create-card">
      <mat-card-content>
        <div class="form-grid">
          <mat-form-field appearance="outline">
            <mat-label>Project *</mat-label>
            <mat-select [(ngModel)]="projectId" (ngModelChange)="onProjectChange($event)">
              @for (p of projects(); track p.id) {
                <mat-option [value]="p.id">{{ p.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Related task *</mat-label>
            <mat-select [(ngModel)]="relatedTaskId">
              @for (t of tasks(); track t.id) {
                <mat-option [value]="t.id">{{ t.title }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Related issue</mat-label>
            <mat-select [(ngModel)]="relatedIssueId">
              <mat-option value="">None</mat-option>
              @for (i of issues(); track i.id) {
                <mat-option [value]="i.id">{{ i.key }} — {{ i.summary }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full">
            <mat-label>Title *</mat-label>
            <input matInput [(ngModel)]="title" maxlength="300" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="full">
            <mat-label>Description</mat-label>
            <textarea matInput rows="2" [(ngModel)]="description"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Severity</mat-label>
            <mat-select [(ngModel)]="severity">
              @for (s of severityOptions; track s.value) {
                <mat-option [value]="s.value">{{ s.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Category</mat-label>
            <mat-select [(ngModel)]="category">
              @for (c of categoryOptions; track c.value) {
                <mat-option [value]="c.value">{{ c.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full">
            <mat-label>Steps to reproduce</mat-label>
            <textarea matInput rows="2" [(ngModel)]="steps"></textarea>
          </mat-form-field>
        </div>
        <button mat-raised-button color="warn"
          [disabled]="saving() || !projectId || !relatedTaskId || !title.trim()"
          (click)="create()">
          {{ saving() ? 'Saving…' : 'Create Bug' }}
        </button>
      </mat-card-content>
    </mat-card>
  }

  @if (loading()) {
    <div class="loading"><mat-spinner diameter="36"></mat-spinner></div>
  } @else {
    <mat-card>
      <table mat-table [dataSource]="bugs()" class="full">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let b">
            <button mat-button type="button" (click)="openBug(b.id)">{{ b.title }}</button>
          </td>
        </ng-container>
        <ng-container matColumnDef="severity">
          <th mat-header-cell *matHeaderCellDef>Severity</th>
          <td mat-cell *matCellDef="let b">{{ severityLabel(b.severity) }}</td>
        </ng-container>
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef>Category</th>
          <td mat-cell *matCellDef="let b">{{ categoryLabel(b.category) }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let b">
            <mat-select [value]="b.status" (selectionChange)="updateStatus(b, $event.value)" class="status-select">
              @for (s of statusOptions; track s.value) {
                <mat-option [value]="s.value">{{ s.label }}</mat-option>
              }
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="relatedTaskId">
          <th mat-header-cell *matHeaderCellDef>Task</th>
          <td mat-cell *matCellDef="let b">{{ taskTitle(b.relatedTaskId) }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let b">
            <button mat-icon-button type="button" (click)="openBug(b.id)"><mat-icon>open_in_new</mat-icon></button>
            <button mat-icon-button color="warn" type="button" (click)="deleteBug(b)"><mat-icon>delete</mat-icon></button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
      @if (!bugs().length) {
        <p class="empty">No bugs reported yet.</p>
      }
    </mat-card>
  }
</div>
